import React from "react"

import { getCanonicalUrl } from "./utils"

type Props = {
  pathname: string
}

export function CanonicalTag({ pathname }: Props) {
  return (
    <link
      rel="canonical"
      href={getCanonicalUrl(pathname)}
      data-baseprotocol="https:"
      data-basehost="www.tremendous.com"
    />
  )
}
